import React from 'react';
import { useSelector } from 'react-redux';
import { selectTeamLeaderBoardGraph } from 'Selector/SRISelector';
import styled from 'styled-components';
import { TeamLeaderBoardDataIn } from 'Types/SRITypes';
import NestingStatsBar from './NestingStatsBar';
import TeamChartBodyItem from './TeamChartBodyItem';

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 50px;
  .table-item {
    >div{
      /* padding-bottom: 10px; */
    }
  }
  .progress-bar{
    div{
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .other-side {
    width: 64%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    height: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 60%;
    }
    .line-for-chart {
      width: 0.5px;
      height: 100%;
      background-color: #CECECE;
      position: absolute;
      &:nth-child(1) {
       left: 0;
       top: 20px;
      }
      &:nth-child(2) {
       left: 112px;
       top: 20px;
      }
      &:nth-child(3) {
       left: 224px;
       top: 20px;
      }
      &:nth-child(4) {
       left: 336px;
       top: 20px;
      }
      &:nth-child(5) {
       left: 502px;
       top: 20px;
       @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        display: none;
       }
      }
    }
  }
`;

const TeamChartBody = function TeamChartBody() {
  const teamLeaderBoardGraph: TeamLeaderBoardDataIn[] = useSelector(selectTeamLeaderBoardGraph);
  const filteredData = teamLeaderBoardGraph || [];

  return (
    <>
      {filteredData?.map((person) => (
        <Wrapper className="table-body">
          <TeamChartBodyItem
            belt={person.level && person.level?.image}
            image={person.image}
            name={person.name}
            certified={person.certified}
            count={person.rank1}
            scoreBreakdowResults={person?.score_breakdown_results}
          >
            <NestingStatsBar
              xiqAppPercentage={`${person.score_breakdown_results_graph.find((type) => type.name === 'xiQ App')?.percentage || 0}%`}
              dailyIqPercentage={`${person.score_breakdown_results_graph.find((type) => type.name === 'Daily IQ Email')?.percentage || 0}%`}
              alertPercentage={`${person.score_breakdown_results_graph.find((type) => type.name === 'Notifications')?.percentage || 0}%`}
            />
          </TeamChartBodyItem>
        </Wrapper>
      ))}
      <div className="table-body" />
    </>
  );
};

export default TeamChartBody;
